var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0808 2.66675H24.7727V6.12887H21.3106V8.43695H24.7727V11.8991H27.0808V8.43695H30.5429V6.12887H27.0808V2.66675Z",
    fill: "#B4B4B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9083 3.82079C14.2144 3.82079 14.5079 3.94237 14.7244 4.1588L29.7269 19.1613C30.1776 19.612 30.1776 20.3427 29.7269 20.7934L20.9726 29.5477C20.5219 29.9984 19.7912 29.9984 19.3405 29.5477L4.33801 14.5452C4.12158 14.3287 4 14.0352 4 13.7291V6.12887C4 4.85415 5.03336 3.82079 6.30808 3.82079H13.9083ZM8.03914 9.59099C8.99518 9.59099 9.7702 8.81597 9.7702 7.85993C9.7702 6.90389 8.99518 6.12887 8.03914 6.12887C7.0831 6.12887 6.30808 6.90389 6.30808 7.85993C6.30808 8.81597 7.0831 9.59099 8.03914 9.59099Z",
    fill: "#B4B4B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0808 2.66675H24.7727V6.12887H21.3106V8.43695H24.7727V11.8991H27.0808V8.43695H30.5429V6.12887H27.0808V2.66675Z",
    fill: "#B4B4B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9083 3.82079C14.2144 3.82079 14.5079 3.94237 14.7244 4.1588L29.7269 19.1613C30.1776 19.612 30.1776 20.3427 29.7269 20.7934L20.9726 29.5477C20.5219 29.9984 19.7912 29.9984 19.3405 29.5477L4.33801 14.5452C4.12158 14.3287 4 14.0352 4 13.7291V6.12887C4 4.85415 5.03336 3.82079 6.30808 3.82079H13.9083ZM8.03914 9.59099C8.99518 9.59099 9.7702 8.81597 9.7702 7.85993C9.7702 6.90389 8.99518 6.12887 8.03914 6.12887C7.0831 6.12887 6.30808 6.90389 6.30808 7.85993C6.30808 8.81597 7.0831 9.59099 8.03914 9.59099Z",
    fill: "#B4B4B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0808 2.66675H24.7727V6.12887H21.3106V8.43695H24.7727V11.8991H27.0808V8.43695H30.5429V6.12887H27.0808V2.66675Z",
    fill: "#B4B4B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9083 3.82079C14.2144 3.82079 14.5079 3.94237 14.7244 4.1588L29.7269 19.1613C30.1776 19.612 30.1776 20.3427 29.7269 20.7934L20.9726 29.5477C20.5219 29.9984 19.7912 29.9984 19.3405 29.5477L4.33801 14.5452C4.12158 14.3287 4 14.0352 4 13.7291V6.12887C4 4.85415 5.03336 3.82079 6.30808 3.82079H13.9083ZM8.03914 9.59099C8.99518 9.59099 9.7702 8.81597 9.7702 7.85993C9.7702 6.90389 8.99518 6.12887 8.03914 6.12887C7.0831 6.12887 6.30808 6.90389 6.30808 7.85993C6.30808 8.81597 7.0831 9.59099 8.03914 9.59099Z",
    fill: "#B4B4B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0808 2.66675H24.7727V6.12887H21.3106V8.43695H24.7727V11.8991H27.0808V8.43695H30.5429V6.12887H27.0808V2.66675Z",
    fill: "#B4B4B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9083 3.82079C14.2144 3.82079 14.5079 3.94237 14.7244 4.1588L29.7269 19.1613C30.1776 19.612 30.1776 20.3427 29.7269 20.7934L20.9726 29.5477C20.5219 29.9984 19.7912 29.9984 19.3405 29.5477L4.33801 14.5452C4.12158 14.3287 4 14.0352 4 13.7291V6.12887C4 4.85415 5.03336 3.82079 6.30808 3.82079H13.9083ZM8.03914 9.59099C8.99518 9.59099 9.7702 8.81597 9.7702 7.85993C9.7702 6.90389 8.99518 6.12887 8.03914 6.12887C7.0831 6.12887 6.30808 6.90389 6.30808 7.85993C6.30808 8.81597 7.0831 9.59099 8.03914 9.59099Z",
    fill: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTag);
export default __webpack_public_path__ + "static/media/AddTag.060008f432e3b55223b924c3f04bea06.svg";
export { ForwardRef as ReactComponent };